export default "/imgs/tag/2020.svg"